<div class="p-4 flex flex-col justify-center items-center">
  <input type="text" class="rounded border-gray-400 outline-black p-3 m-4 w-1/4" id="username" aria-describedby="username" placeholder="Enter your Username">
  <input type="password" class="rounded border-gray-400 outline-black p-3 m-4 w-1/4" id="password" placeholder="Password">
  <button (click)="authservice.loginWithRedirect()"  type="submit" class="bg-green-400 rounded  border-1 outline-none p-3 m-4 text-gray-50 w-1/4 hover:bg-white hover:text-green-400 hover:border-green-400 ">Log In</button>

  <a class="m-4 font-semibold no-underline text-center cursor-pointer">Create new account</a>
  <div class="shadow-md rounded bg-white p-2 flex flex-row justify-center items-center w-1/4 cursor-pointer hover:shadow-lg">
    <img src="../../../assets/images/google.png" alt="google" class="m-2">
    <p class="m-2">Sign in with Google</p>
  </div>
</div>
